export default {
  LOAD_STUDENT_COMPETENCY_SURVEY_OVERVIEW_PAGE_START: 'LoadStudentCompetencySurveyOverviewPageStart',
  LOAD_STUDENT_COMPETENCY_SURVEY_OVERVIEW_PAGE_END: 'LoadStudentCompetencySurveyOverviewPageEnd',
  SELECT_STUDENT_COMPETENCY_SURVEY_OVERVIEW_PAGE_TAB: 'SelectStudentCompetencySurveyOverviewPageTab',
  TOGGLE_STUDENT_COMPETENCY_REQUEST_EVALUATION_DIALOG: 'ToggleStudentCompetencyRequestEvaluationDialog',
  CLEAR_STUDENT_COMPETENCY_SURVEY_OVERVIEW_PAGE: 'ClearStudentCompetencySurveyOverviewPage',
  TOGGLE_STUDENT_COMPETENCY_SURVEY_QR_CODE_DIALOG: 'ToggleStudentCompetencySurveyQrCodeDialog',
  SET_STUDENT_COMPETENCY_SURVEY_SHOW_QR_CODE_SETTING: 'SetStudentCompetencyShowQrCodeSetting',
  TOGGLE_STUDENT_COMPETENCY_SURVEY_CONFIRM_DIALOG: 'ToggleStudentCompetencySurveyConfirmDialog',
  SEND_STUDENT_COMPETENCY_SURVEY_NOTIFICATION_START: 'SendStudentCompetencySurveyNotificationStart',
  SEND_STUDENT_COMPETENCY_SURVEY_NOTIFICATION_END: 'SendStudentCompetencySurveyNotificationEnd'
};
